<template>
  <!-- 提示 -->
  <div class="subject-prompt">
    <!-- 错误 -->
    <div :class="{ 'subject-prompt-error': !isTrue }">
      <mu-button :color="iconColor" class="subject-prompt-icon" icon>
        <mu-icon :value="icon"></mu-icon>
      </mu-button>

      <span class="subject-prompt-text" v-html="anaText"></span>
    </div>

    <!-- 错误解析 -->
    <p v-show="analysisStr">
      答题解析：
      <span>{{ analysisStr }}</span>
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    analysisStr: String,
    isTrue: Boolean,
    answerOpt: String,
  },
  data() {
    return {}
  },
  computed: {
    icon() {
      return this.isTrue ? 'thumb_up' : ' thumb_down'
    },
    iconColor() {
      return this.isTrue ? 'blue' : 'red'
    },
    anaText() {
      const m1 = this.isTrue ? '回答正确' : '正确答案为'
      const m2 = this.answerOpt
      return `${m1}：${m2}`
    },
  },
  watch: {},
  created() {},
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {},
  filter: {},
}
</script>

<style lang="scss" scoped></style>
<style lang="scss"></style>
